export class Organisation {
    constructor(id, name, authMethod) {
        this.id = id;
        this.name = name;
        this.authMethod = authMethod;
    }
}
